import React, { FC } from "react";
import Image from "next/image";
import GlobalSearch from "@components/common/GlobalSearch";

interface Props {
  query?: string;
  currentTabSelectedTitle?: string;
}

const NotFoundSearch: FC<Props> = ({
  query = "",
  currentTabSelectedTitle = "",
}) => {
  return (
    <div className="container mx-auto flex items-center md:px-0">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-center">
        {/* Left Section */}
        <div className="flex flex-col justify-center space-y-2">
          <p className="text-gray-600 text-2xl pb-4">
            No results in{" "}
            <span className="font-semibold">
              {query ? query : currentTabSelectedTitle}
            </span>
          </p>

          <h3 className="text-black text-4xl font-bold">Are you lost?</h3>
          <h3 className="text-black text-2xl">
            That’s why you need to hire our expert guides.
          </h3>
          <div className="w-full max-w-md pt-4">
            <GlobalSearch
              className="bg-gray-100 px-7 py-4 w-full rounded-lg"
              placeholder="Search for private tours"
            />
          </div>
        </div>

        {/* Right Section */}
        {/*extra: lg:justify-end */}
        <div className="flex justify-center">
          <Image
            className="w-full max-w-[180px] lg:max-w-[250px]"
            src="/gif/404_character.gif"
            alt="404 character"
            width={400}
            height={400}
            style={{
              maxWidth: "50%",
              height: "auto",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundSearch;
